import React, { useCallback, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { getUserInformationAction, updateUserInformationAction } from "../../../../state/usecase/admin/user/actions";
import { useAppDispatch } from "../../../../state/store";
import { UserId } from "../../../../domain/user/UserId";
import { UserName } from "../../../../domain/user/UserName";
import { Loading } from "../../common/Loading";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { getCareRecipientListAction } from "../../../../state/usecase/admin/care_recipient/actions";
import { BackButton } from "../../common/button/BackButton";
import { useUserInformation } from "../../../hooks/admin/user/useUserInformation";
import { useCareRecipientList } from "../../../hooks/admin/care_recipient/useCareRecipientList";
import { UserInfoEditComponent } from "./UserInfoEditComponent";
import { UserEditType } from "../../../../domain/user/User";

type AdminUserUpdatePagePathParams = {
    userId: string
}

export function AdminUserUpdatePage() {
    const dispatch = useAppDispatch();

    const params = useParams<AdminUserUpdatePagePathParams>();

    const userId = useMemo<UserId | null>(() => {
        if (!params.userId) return null;
        return UserId.fromString(params.userId);
    }, [params.userId]);

    const userInformation = useUserInformation();

    const careRecipientList = useCareRecipientList();

    useEffect(() => {
        if (!userId) return;
        dispatch(getUserInformationAction(userId));
        dispatch(getCareRecipientListAction());
    }, [dispatch, userId]);

    const handleUpdateClicked = useCallback((name: string, _email: string, _password: string, _role: string, careRecipients: string[]) => {
        if (!userId) return;
        dispatch(
            updateUserInformationAction({
                userId: userId,
                userName: UserName.fromString(name),
                viewableCareRecipients: careRecipients.map((careRecipient) => CareRecipientId.fromString(careRecipient))
            })
        );
    }, [dispatch, userId]);

    // レスポンス取得中
    if (!userInformation || !careRecipientList) return <Loading/>;

    return (
        <div className={"user_edit_page"}>
            <div className={"container"}>
                <BackButton/>
                <p className={"header"}>ユーザー更新</p>
                <UserInfoEditComponent
                    editType={UserEditType.UPDATE}
                    userName={userInformation.name}
                    userEmail={userInformation.email}
                    userRole={userInformation.role}
                    careRecipientList={careRecipientList}
                    whenSaveButtonClicked={handleUpdateClicked}
                />
            </div>
        </div>
    );
}
